// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PatientList_wrapper__3_o6j","head":"PatientList_head__WMMPc"};